import React from "react";

const EnquiryModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          backdropFilter: "blur(3px)",
          zIndex: 999,
        }}
      />

      {/* Modal Wrapper */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "15px",
          zIndex: 1000,
        }}
      >
        {/* Modal Card */}
        <div
          className="bg-white rounded-4 shadow-lg w-100"
          style={{
            maxWidth: "750px",
            maxHeight: "90vh",
            overflowY: "auto",
            animation: "fadeIn 0.3s ease-in-out",
          }}
          onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
        >
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center p-3 p-md-4 border-bottom bg-success text-white rounded-top-4">
            <h5 className="fw-bold m-0">Product Enquiry</h5>
            <button
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>

          {/* BODY */}
          <div className="p-3 p-md-4">
            <form>
              <div className="row g-3">

                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your name"
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold">Phone Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter phone number"
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email"
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold">
                    Product Interested In
                  </label>
                  <select className="form-select">
                    <option>Select Product</option>
                    <option>Mango</option>
                    <option>Apple</option>
                    <option>Pomegranate</option>
                    <option>Banana</option>
                  </select>
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Message</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Write your enquiry..."
                  ></textarea>
                </div>
              </div>

              {/* FOOTER */}
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-success px-4">
                  Submit Enquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Animation Style */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
        `}
      </style>
    </>
  );
};

export default EnquiryModal;
